export enum UnknownErrorCodes {
  UNKNOWN
}

export enum RejectErrorType {
  UNKNOWN,
  API,
  ZENDESK
}

export interface RejectError {
  readonly message: string;
  readonly code: number;
  readonly type: RejectErrorType;
}
